/* eslint-disable */
import $ from 'jquery'
import Mark from 'mark.js'

function do_debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
function run_debounce(){
  markWords();
}
const debounce = do_debounce(() => run_debounce());


const searchableContent = new Mark( document.querySelector("div.entryContent") )

const markWords = function() {
    let keyword = $('#accordion-keyword').val()

    searchableContent.unmark({
        done: function() {
          searchableContent.mark(keyword, {
            accuracy: 'complementary',
            done: function() {
                let match = false
                $('#accordion-message').html('')
                $('.accordion-card').each(function () {
                    if( keyword == '' )   
                        $(this).show().find('.accordion-card-content').removeClass('accordion-is-open')

                    else if( $(this).find('mark').length ) {
                        match = true
                        $(this).show().find('.accordion-card-content').addClass('accordion-is-open')
                    }

                    else    
                        $(this).hide().find('.accordion-card-content').removeClass('accordion-is-open')
                })

                !match && keyword != '' ? $('#accordion-search-message').html('No matches found.') : $('#accordion-search-message').html('')
            }
        })
        }
    })
}





const init = () => {

    if( !$('.accordion-card').length ) return

    $("#accordion-keyword").on("change keyup paste", debounce)
        
    $('.accordion-card-content >:first-child').on('click', function () {
        // let keyword = $('#accordion-keyword').val() // stop expanding when search is active, breaks when search input is not on page
        // if( keyword == '') {
          $(this).parent().toggleClass('accordion-is-open') 
        // }
    })
}

export default {
  init,
}
